import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Zap, Shield, Check } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <Activity className="w-6 h-6 text-gold-500" data-id="element-15" />,
    title: 'Aumentar el control percibido',
    desc: 'durante las relaciones.'
  }, {
    icon: <Zap className="w-6 h-6 text-gold-500" data-id="element-16" />,
    title: 'Elevar la sensación',
    desc: 'sin adormecer ni eliminar el placer.'
  }, {
    icon: <Shield className="w-6 h-6 text-gold-500" data-id="element-17" />,
    title: 'Disfrutar con más confianza',
    desc: 'sabiendo que tenés una ayuda práctica.'
  }, {
    icon: <Check className="w-6 h-6 text-gold-500" data-id="element-18" />,
    title: 'Apto para usar con preservativos',
    desc: '(base compatible).'
  }];
  return <section className="w-full bg-dark-900 py-24 px-4" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-22">
            El Gel Gold no "cura nada".
            <br data-id="element-23" />
            <span className="text-gold-500" data-id="element-24">
              Pero sí te ayuda a ganar control sobre la sensación.
            </span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-25">
            Es un gel íntimo estimulante con textura suave, aplicación rápida y
            efecto diseñado para:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-26">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-dark-800 p-6 rounded-xl border border-white/5 flex items-start gap-4 hover:border-gold-500/30 transition-colors" data-id="element-27">
              <div className="p-3 bg-gold-500/10 rounded-lg shrink-0" data-id="element-28">
                {benefit.icon}
              </div>
              <div data-id="element-29">
                <h3 className="text-white font-bold text-lg mb-1" data-id="element-30">
                  {benefit.title}
                </h3>
                <p className="text-gray-400" data-id="element-31">{benefit.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="text-center mt-12" data-id="element-32">
          <p className="text-gray-500 italic" data-id="element-33">
            No es magia. Es química simple aplicada donde más importa.
          </p>
        </motion.div>
      </div>
    </section>;
}